export const subRegionMap = {
    'UWA6': 'West',
    'UNJ2': 'East',
    'USV1': 'EU',
    'ULO1': 'EU',
    'USF1': 'West',
    'USF2': 'West',
    'UOH4': 'Central',
    'UTX3': 'Central',
    'UNY5': 'East',
    'UIL2': 'Central',
    'UFL6': 'East',
    'UBA1': 'EU',
    'ULI2': 'EU',
    'UWI2': 'Central',
    'UTN1': 'Central',
    'UNY4': 'East',
    'UTX4': 'Central',
    'UNV2': 'West',
    'UCA5': 'West',
    'UFL5': 'East',
    'UVA4': 'East',
    'DCA2': 'NA',
    'UMD1': 'East',
    'ULO6': 'EU',
    'UMC3': 'EU',
    'UMU1': 'EU',
    'UNC3': 'East',
    'UMA4': 'East',
    'UVL1': 'EU',
    'UIT7': 'EU',
    'ULA6': 'West',
    'USF4': 'West',
    'UNY2': 'East',
    'UOH5': 'Central',
    'UNV3': 'West',
    'UTX9': 'Central',
    'UDE6': 'EU',
    'UUK2': 'EU',
    'UUK3': 'EU',
    'UAZ1': 'West',
    'UMN1': 'Central',
    'UES3': 'EU',
    'UHA1': 'EU',
    'UTX8': 'Central',
    'UIT4': 'EU',
    'UCA4': 'West',
    'UTR1': 'EU',
    'UWA2': 'West',
    'ULO5': 'EU',
    'UIN1': 'Central',
    'UCO1': 'West',
    'UCA1': 'West',
    'UJF2': 'FE',
    'UPA1': 'East',
    'UGA2': 'East',
    'UWA1': 'West',
    'UFL4': 'East',
    'UOR2': 'West',
    'UES4': 'EU',
    'UNC2': 'East',
    'UVA5': 'East',
    'UGA4': 'East',
    'UVA1': 'East',
    'UJF1': 'FE',
    'UIT1': 'EU',
    'UTX7': 'Central',
    'UUK1': 'EU',
    'JFK2': 'East',
    'UZR1': 'EU',
    'USD1': 'West'
};

export const DEFAULT_SUB_REGION = 'Other';
